import BasketballForm from "./Basketball";
import HandballForm from "./Handball";
import HockeyForm from "./Hockey";
import Ice3Form from "./Ice3";

const FormContent = ({ sport, form }) => {
  if (sport === "basketball") return <BasketballForm form={form} showPointsFourAllowed />;
  if (sport === "hockey") return <HockeyForm />;
  if (sport === "ice3") return <Ice3Form />;
  if (sport === "handball") return <HandballForm />;

  return <BasketballForm form={form} showPointsFourAllowed={false} />;
};

export default FormContent;
